import React from "react"
import Paper from "material-ui/Paper"
import ImageLoader from "../../../misc/ImageLoader"
import strings from "../../../../localization/strings"
import * as exceptionHelper from "../../../../helpers/exceptionHelper"
import { green500, green50, orange900, deepOrange50, amber500 } from "material-ui/styles/colors"
import { IRecord, EExceptionType, IPunchException, EExceptionState } from "../../../../models"
import ExceptionBody from "../exception_body/ExceptionBody"
import * as hierarchyHelper from "../../../../helpers/hierarchyHelper"
import ExceptionReviewedInfo from "../exception_body/ExceptionReviewedInfo"
interface IProps {
	exception: IPunchException
	record: IRecord
}

const LocationExceptionInfo: React.SFC<IProps> = (props: IProps) => {
	const exceptionType = props.exception.TypeEnum
	const exceptionState = exceptionHelper.getExceptionState(props.exception)
	const distance = exceptionType === EExceptionType.LOCATION &&
		(props.record.Punch.MetaData.DistanceToLocation >= 1000 ?
			props.record.Punch.MetaData.DistanceToLocation / 1000 :
			props.record.Punch.MetaData.DistanceToLocation
		).toFixed(props.record.Punch.MetaData.DistanceToLocation > 10000 ? 0 : 2)
	const distanceUnit = exceptionType === EExceptionType.LOCATION && (props.record.Punch.MetaData.DistanceToLocation >= 1000 ? "km" : strings.meters)
	let distanceStr = ""
	let punchLevelStr = ""
	let punchLevelType = ""
	if (exceptionType === EExceptionType.LOCATION) {
		distanceStr = `${distance} ${distanceUnit}`
		punchLevelStr = props.record.Punch.JobId ?
			`${strings.Job}: ${props.record.Punch.JobCostCode ? `${props.record.Punch.JobCostCode} - ` : ""}${props.record.Punch.JobName}` :
			hierarchyHelper.getFullyQualifiedLevelNameById(props.record.Punch.HierarchyItemId)
		punchLevelType = props.record.Punch.JobId ? strings.Job : strings.Hierarchy
	}

	return (
		<div
			style={{
				background: exceptionState === EExceptionState.Review ? amber500 : exceptionState === EExceptionState.Approved ? green500 : orange900,
				color: exceptionState === EExceptionState.Review ? orange900 : exceptionState === EExceptionState.Approved ? green50 : deepOrange50,
				padding: 10,
				minHeight: 350,
				display: "flex",
				position: "relative"
			}}
		>
			<ExceptionReviewedInfo
				style={{ position: "absolute", right: 15, bottom: 15 }}
				hierarchyId={props.record.Punch.HierarchyItemId}
				jobId={props.record.Punch.JobId}
				exception={props.exception}
			/>
			<div style={{ position: "absolute", right: 15, bottom: 15 }}></div>
			{props.record.Punch.ImageID &&
				<div>
					<Paper>
						<ImageLoader
							url={props.record.Punch.ImageS3Url}
							fixedHeight={350}
							maxWidth={275}
							src={"/punches/image/" + props.record.Punch.ImageID}
						/>
					</Paper>
					<div style={{ textTransform: "uppercase", marginTop: 10, fontSize: 16, fontWeight: "bold" }}>{strings.Geofence_Violation}</div>
				</div>
			}
			<div>
				<div style={{ fontSize: 40, marginTop: 40, marginLeft: 18 }}>
					{exceptionType === EExceptionType.LOCATION ?
						strings.Punch_Outside_Geofence :
						exceptionType === EExceptionType.MICRO_LOCATION ?
							strings.No_Microlocation_In_Range :
							exceptionType === EExceptionType.NO_LOCATION_OR_MICROLOCATION ?
								strings.No_GPSBeacon :
								exceptionType === EExceptionType.NO_DEVICE_LOCATION &&
								strings.No_Device_Location
					}
				</div>
				<div style={{ display: "flex" }}>
					<div style={{ marginLeft: 20, maxWidth: 500 }}>
						<div style={{ marginTop: 20 }}>
							{exceptionType === EExceptionType.NO_DEVICE_LOCATION ?
								strings.No_Device_Location_exception_description :
								exceptionType === EExceptionType.LOCATION &&
								strings.formatString(strings.LOCATION_exception_description, distanceStr, punchLevelStr, punchLevelType)
							}
						</div>
						<div style={{ marginTop: (exceptionType === EExceptionType.NO_DEVICE_LOCATION || exceptionType === EExceptionType.LOCATION) ? 25 : 80 }}>
							<ExceptionBody record={props.record} />
						</div>
					</div>
					<div style={{ position: "relative", marginLeft: 30 }}>
						<span className="fa-stack" style={{ fontSize: 90, marginTop: 15 }}>
							<i className="fa fa-square-o fa-stack-2x" />
							<i className={`fa fa-${exceptionState === EExceptionState.Review ? "warning" : exceptionState === EExceptionState.Approved ? "check" : "close"} fa-stack-1x`} />
						</span>
						{exceptionType === EExceptionType.LOCATION &&
							<div style={{ position: "absolute", right: 40, marginTop: 30 }}>
								<span style={{ fontSize: 85, fontWeight: 500 }}>
									{distance}
								</span>
								<span style={{ fontSize: 15 }}>
									{distanceUnit}
								</span>
							</div>
						}
					</div>
				</div>
			</div>
		</div >
	)
}

export default LocationExceptionInfo
